import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import css from './ServicesPanel.scss';
import ServicesSection from './ServicesSection';
import { SFServices } from 'utils/types';

export default class ServicesPanel extends React.Component {

	constructor() {
		super();
		this.state = { showOtherServices: false }
	}

	componentDidUpdate(prevProps, prevState) {
		if ( this.state.showOtherServices && !prevState.showOtherServices ) {
			// If we've just toggled other services to display, focus the first url in the section
			document.querySelector('#Other-Services a').focus();
		}
	}

	handleToggleOtherServicesClick() {
		// Scroll to top when hiding services
		if ( this.state.showOtherServices ) document.querySelector('#Your-Services').scrollIntoView();
		this.setState({showOtherServices: !this.state.showOtherServices});
	}

	get toggleOtherServicesButtonText() {
		return `${this.state.showOtherServices ? "Hide" : "Show"} other services`;
	}

	get otherServices() {
		if ( !this.state.showOtherServices ) return null;
		return (
			<ServicesSection
				sectionName="Other Services"
				services={this.props.services.filter(service => service.isOtherService)}
				isStaff={this.props.isStaff}
				isServiceMember={this.props.isServiceMember}
				isStudent={this.props.isStudent}
				canSeeStudentServices={this.props.canSeeStudentServices}
				canMakeAppointment={this.props.canMakeAppointment}
				hasConnectLicense={this.props.hasConnectLicense}
				responsiveKioskEnabled={this.props.responsiveKioskEnabled}
				virtualCheckInEnabled={this.props.virtualCheckInEnabled}
			/>
		);
	}

	render() {
		return (
			<div>
				<ServicesSection
					sectionName="Your Services"
					services={this.props.services.filter(service => service.inSuccessNetwork)}
					isStaff={this.props.isStaff}
					isServiceMember={this.props.isServiceMember}
					isStudent={this.props.isStudent}
					canSeeStudentServices={this.props.canSeeStudentServices}
					canMakeAppointment={this.props.canMakeAppointment}
					hasConnectLicense={this.props.hasConnectLicense}
					responsiveKioskEnabled={this.props.responsiveKioskEnabled}
					virtualCheckInEnabled={this.props.virtualCheckInEnabled}
				/>
				{this.otherServices}
				<div style={{marginTop: "0px"}}>
					<Button
						onClick={this.handleToggleOtherServicesClick.bind(this)}
						className={css["other-services-button"]}>
						{this.toggleOtherServicesButtonText}
					</Button>
				</div>
			</div>
		);
	}
}

ServicesPanel.propTypes = {
	services: SFServices.isRequired,
	isStaff: PropTypes.bool.isRequired,
	isServiceMember: PropTypes.bool.isRequired,
	isStudent: PropTypes.bool.isRequired,
	canSeeStudentServices: PropTypes.bool,
	canMakeAppointment: PropTypes.bool,
	hasConnectLicense: PropTypes.bool,
	responsiveKioskEnabled: PropTypes.bool,
	virtualCheckInEnabled: PropTypes.bool,
};
